import React from "react";
import { Link } from "react-router-dom";
import AuthHelper from "../../helper/AuthHelper";

const LoggedInName = (props) => {
  return (
    <div className="flex flex-grow justify-end">
      <Link to="/" onClick={() => AuthHelper.removeUserToken()}>
        <span className="px-4 py-2 text-grey-darkest opacity-50 text-2xl">
          {AuthHelper.getUserToken() && `Log Out`}
        </span>
      </Link>
    </div>
  );
};

export default LoggedInName;
